import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Navigator from "../../../layouts/Navigator/Navigator";
import EditableConfigurationName from "../../../components/common/EndPage/EditableConfigurationName/EditableConfigurationName";
import CorrespondingCountry from "../../../components/Retrofit/CorrespondingCountry/CorrespondingCountry";
import ActionLinks from "../../../components/common/EndPage/ActionLinks/ActionLinks";
import Documentation from "../../../components/common/EndPage/Documentation/Documentation";
import ConfigurationSaved from "../../../components/common/EndPage/ConfigurationSaved/ConfigurationSaved";
import { resetMc12, selectMc12Configuration } from "../../../store/slices/mc12";
import t from "../../../utils/common/translation/translator";
import BillOfMaterials from "../../../components/Mc12/BillOfMaterials/BillOfMaterials";
import { gatherMc12ProductsForBOM } from "../../../utils/Mc12/func.utils";
import { selectEventsData, setFullScreen } from "../../../store/slices/common";
import { logEvent } from "../../../utils/common/api/api";

const Finalize = () => {
  const dispatch = useDispatch();
  const configuration = useSelector(selectMc12Configuration);
  const products = gatherMc12ProductsForBOM(configuration.configData.track);
  const eventsData = useSelector(selectEventsData);

  useEffect(() => {
    logEvent(eventsData.locale, eventsData.types.save, eventsData.tags.none, configuration?.configId);
  }, [eventsData]);

  return (
    <>
      <div className="flex flex-row gap-5">
        <div className="flex flex-col w-2/3">
          <div className="flex justify-between">
            <EditableConfigurationName />
            {/* Here need to retrieve country from config data */}
            <CorrespondingCountry
              country={configuration.configData.country === "GB" ? "UK" : configuration.configData.country}
            />
          </div>
          <BillOfMaterials productsList={products} />
        </div>
        <div className="flex flex-col gap-5  w-1/3">
          <ConfigurationSaved />
          <div className="flex flex-col gap-4">
            <ActionLinks />
            <Documentation referenceIds={products.map((product) => product.commercialReference)} />
          </div>
        </div>
      </div>
      <Navigator
        continueLabel={t("msizer.ui.footer.go_to_start_page")}
        continueAction={() => {
          dispatch(resetMc12());
          dispatch(setFullScreen(false));
        }}
      />
    </>
  );
};
export default Finalize;
